import React, { useEffect, useState } from "react";
import "./viewRecipts.scss";
import DataTable from "react-data-table-component";
import AllServices from "../../../Services/AllServices";
import { toast } from "react-toastify";
import CustomLoader from "../../../components/CustomLoader/CustomLoader";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { RecepitURLServer } from "../../../Constants/Constants";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const recepitURL = RecepitURLServer;

const ViewRecipts = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    page: 1,
    rowsPerPage: 10,
  });
  const [records, setRecords] = useState(0);
  const [openModel, setOpenModel] = useState(false);
  const [recepitName, setRecepitName] = useState("");

  // ─── Check Receipt by Date state ───────────────────────────────────────────
  const [checkDate, setCheckDate] = useState("");
  const [checkLoading, setCheckLoading] = useState(false);
  const [checkResult, setCheckResult] = useState(null);
  const [checkError, setCheckError] = useState("");
  const [openCheckModel, setOpenCheckModel] = useState(false);
  const [checkRecepitName, setCheckRecepitName] = useState("");

  const handlePageChange = (page) => {
    setSearchParams((prev) => ({
      ...prev,
      page,
    }));
  };

  const handleRowsPerPageChange = (newRowsPerPage, page) => {
    setSearchParams((prev) => ({
      ...prev,
      rowsPerPage: newRowsPerPage,
      page: 1,
    }));
  };

  let dataObj = {
    page: searchParams.page,
    rowsPerPage: searchParams.rowsPerPage,
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await AllServices.getAllRecepitDetails(dataObj);

      if (response.data.succuss) {
        setData(response.data.data);
        setRecords(response.data.pagination.totalRecords);

        // Save the latest (first) receipt record to localStorage
        const latestReceipt = response.data.data[0];
        if (latestReceipt) {
          localStorage.setItem("latestReceipt", JSON.stringify(latestReceipt));
        }
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const lastUpdatedRaw =
    data && data.length > 0 && data[0].Last_Updated_Date
      ? data[0].Last_Updated_Date
      : null;

  let lastUpdatedDateAndTime = "Something went wrong!";
  let previousdate = "Something went wrong!";

  if (lastUpdatedRaw) {
    const cleanDate = lastUpdatedRaw.split(".")[0];
    const [date, time] = cleanDate.split("T");
    lastUpdatedDateAndTime = `${date}`;

    const prev = new Date(date);
    prev.setDate(prev.getDate() - 1);

    previousdate = prev.toISOString().split("T")[0];
  }

  const isRecepit =
    data && data.length > 0 && data[0].Is_Recepit
      ? "Recepit Downloaded"
      : "No Receipt for the Date Indicated";

  const RecepitName =
    data && data.length > 0 && data[0].Recepit_Name
      ? data[0].Recepit_Name
      : "No Recepit";

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const handleOpen = (row) => {
    const recepitName = row.Recepit_Name;
    if (recepitName) {
      setOpenModel(true);
      setRecepitName(recepitName);
    }
  };

  const handleClose = () => {
    setOpenModel(false);
  };

  // ─── Check Receipt by Date handlers ────────────────────────────────────────
  const handleCheckReceipt = async () => {
    if (!checkDate) {
      toast.warning("Please select a date first.");
      return;
    }
    setCheckLoading(true);
    setCheckResult(null);
    setCheckError("");
    try {
      const response = await AllServices.getOneRecepitDetails({
        date: checkDate,
      });
      if (response && response.data && response.data.success) {
        setCheckResult({ found: true, data: response.data.data });
      }
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        "No Receipt Found for the Selected Date";
      setCheckResult({ found: false, data: [] });
      setCheckError(msg);
    } finally {
      setCheckLoading(false);
    }
  };

  const handleCheckOpen = (row) => {
    if (row.Recepit_Name) {
      setCheckRecepitName(row.Recepit_Name);
      setOpenCheckModel(true);
    }
  };

  const handleCheckClose = () => {
    setOpenCheckModel(false);
  };

  const columns = [
    {
      name: "Last Processed Date",
      selector: (row) => row.Last_Updated_Date.split("T")[0],
      sortable: true,
      minWidth: "160px",
      center: true,
    },
    {
      name: "Receipt Availability",
      selector: (row) => (row.Is_Recepit ? "Yes" : "No"),
      sortable: true,
      minWidth: "160px",
      center: true,
    },
    {
      name: "Receipt Name",
      selector: (row) => (row.Recepit_Name ? row.Recepit_Name : "No Receipt"),
      sortable: true,
      minWidth: "220px",
      center: true,
    },
    {
      name: "Description",
      selector: (row) => row.Description,
      sortable: true,
      minWidth: "250px",
      center: true,
    },
    {
      name: "View",
      cell: (row) => {
        if (!row.Recepit_Name)
          return <span style={{ color: "#94a3b8" }}>- -</span>;

        return (
          <button
            className="icon-wrapper visibility"
            onClick={() => handleOpen(row)}
            type="button"
          >
            <VisibilityIcon className="icon" />
            <span>View Receipt</span>
          </button>
        );
      },
      minWidth: "140px",
      center: true,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "56px",
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #f1f5f9",
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "background-color 0.2s ease",
        },
      },
    },
    headCells: {
      style: {
        backgroundColor: "#0f172a",
        color: "#ffffff",
        fontWeight: "600",
        fontSize: "13px",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        justifyContent: "center",
        fontFamily: "inherit",
        padding: "16px 12px",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        justifyContent: "center",
        color: "#334155",
        fontSize: "13.5px",
        fontFamily: "inherit",
      },
    },
  };

  return (
    <div className="view-container">
      {loading && (
        <div className="loader-overlay">
          <CustomLoader />
        </div>
      )}

      {/* ── Main receipt PDF preview modal ── */}
      {openModel && (
        <div className="loader-overlay">
          <div className="pdf-modal-container">
            <button
              className="close-btn"
              onClick={handleClose}
              aria-label="Close Receipt"
            >
              <CloseIcon />
            </button>
            <div className="modal-header">
              <h3>Receipt Preview</h3>
              <span className="receipt-filename">{recepitName}</span>
            </div>
            <div className="pdf-iframe-wrapper">
              <iframe src={`${recepitURL}${recepitName}`} title="Preview" />
            </div>
          </div>
        </div>
      )}

      {/* ── Check-by-date receipt PDF preview modal ── */}
      {openCheckModel && (
        <div className="loader-overlay">
          <div className="pdf-modal-container">
            <button
              className="close-btn"
              onClick={handleCheckClose}
              aria-label="Close Receipt"
            >
              <CloseIcon />
            </button>
            <div className="modal-header">
              <h3>Receipt Preview</h3>
              <span className="receipt-filename">{checkRecepitName}</span>
            </div>
            <div className="pdf-iframe-wrapper">
              <iframe
                src={`${recepitURL}${checkRecepitName}`}
                title="Check Preview"
              />
            </div>
          </div>
        </div>
      )}

      <div className="view-top">
        <div className="frequency-container">
          <span>
            Frequency: <span className="daily-word">Daily</span>
          </span>
        </div>
      </div>

      <div className="check-receipt-section">
        <div className="check-receipt-header">
          <CalendarMonthIcon className="section-icon" />
          <h4>Check Receipt by Date</h4>
        </div>
        <p className="check-receipt-desc">
          Select a date from the calendar to verify if a receipt was downloaded
          for that specific day.
        </p>

        <div className="check-receipt-controls">
          <div className="date-input-wrapper">
            <label htmlFor="check-date-picker">Select Date</label>
            <input
              id="check-date-picker"
              type="date"
              className="date-picker-input"
              value={checkDate}
              onChange={(e) => {
                setCheckDate(e.target.value);
                setCheckResult(null);
                setCheckError("");
              }}
              max={new Date().toISOString().split("T")[0]}
            />
          </div>

          <button
            className="check-receipt-btn"
            onClick={handleCheckReceipt}
            disabled={checkLoading || !checkDate}
            type="button"
          >
            {checkLoading ? (
              <span className="btn-spinner" />
            ) : (
              <SearchIcon className="btn-icon" />
            )}
            {checkLoading ? "Checking..." : "Check Receipt"}
          </button>
        </div>

        {/* ── Result panel ── */}
        {checkResult && (
          <div
            className={`check-result-panel ${checkResult.found ? "found" : "not-found"
              }`}
          >
            <div className="result-status-row">
              {checkResult.found ? (
                <>
                  <CheckCircleOutlineIcon className="result-icon found-icon" />
                  <span className="result-status-text found-text">
                    Receipt Found for <strong>{checkDate}</strong>
                  </span>
                </>
              ) : (
                <>
                  <ErrorOutlineIcon className="result-icon not-found-icon" />
                  <span className="result-status-text not-found-text">
                    {checkError || `No receipt found for ${checkDate}`}
                  </span>
                </>
              )}
            </div>

            {checkResult.found && checkResult.data.length > 0 && (
              <div className="result-cards">
                {checkResult.data.map((item, idx) => (
                  <div className="result-card" key={idx}>
                    <div className="result-card-row">
                      <span className="result-label">Date</span>
                      <span className="result-value">
                        {item.Last_Updated_Date
                          ? item.Last_Updated_Date.split("T")[0]
                          : "—"}
                      </span>
                    </div>
                    <div className="result-card-row">
                      <span className="result-label">Receipt Name</span>
                      <span className="result-value">
                        {item.Recepit_Name || "No Receipt"}
                      </span>
                    </div>
                    <div className="result-card-row">
                      <span className="result-label">Status</span>
                      <span
                        className={`result-badge ${item.Is_Recepit ? "badge-success" : "badge-error"
                          }`}
                      >
                        {item.Is_Recepit ? "Downloaded" : "Not Downloaded"}
                      </span>
                    </div>
                    <div className="result-card-row">
                      <span className="result-label">Description</span>
                      <span className="result-value">
                        {item.Description || "—"}
                      </span>
                    </div>
                    {item.Recepit_Name && (
                      <button
                        className="icon-wrapper visibility result-view-btn"
                        type="button"
                        onClick={() => handleCheckOpen(item)}
                      >
                        <VisibilityIcon className="icon" />
                        <span>View Receipt</span>
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      <div className="view-bottom">
        <div className="table-responsive-wrapper">
          <DataTable
            columns={columns}
            data={data}
            customStyles={customStyles}
            pagination
            paginationServer
            paginationTotalRows={records}
            paginationPerPage={searchParams.rowsPerPage}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            className="my-table"
            selectableRowsNoSelectAll
            responsive={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewRecipts;
